module.exports = __webpack_public_path__ + "static/img/RAPZ4_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ4_1.png
// module id = 7eUi
// module chunks = 0